export function formatDate(iso, lang = 'en') {
    return new Date(iso).toLocaleDateString(lang === 'pl' ? 'pl-PL' : 'en-GB', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    });
}
export function formatFileSize(bytes) {
    if (bytes < 1024)
        return `${bytes} B`;
    if (bytes < 1024 * 1024)
        return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
